import { useEffect, useState } from "react";
import { Power, Clock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";

export const MaintenancePanel = () => {
  const { can } = useAuth();
  const [on, setOn] = useState(null);

  useEffect(() => {
    api.get("/settings/status").then((r) => setOn(r.data.maintenance_mode));
  }, []);

  const toggle = async () => {
    try {
      const { data } = await api.post("/admin/maintenance/toggle");
      setOn(data.maintenance_mode);
      toast.success(data.maintenance_mode ? "Maintenance AKTIF — pembeli melihat halaman pemeliharaan" : "Maintenance NONAKTIF — website online");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <section className="rk-glass max-w-2xl rounded-2xl p-6" data-testid="maintenance-panel">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="flex items-center gap-2 text-lg font-bold"><Power size={18} className="text-[#e5b80b]" /> Mode Maintenance</h3>
          <p className="mt-1 text-sm text-zinc-400" data-testid="maintenance-state">
            {on === null ? "Memuat…" : on ? "AKTIF — website menampilkan halaman pemeliharaan." : "NONAKTIF — website online normal."}
          </p>
        </div>
        <Switch checked={Boolean(on)} disabled={!can("maintenance", "manage") || on === null} onCheckedChange={toggle} data-testid="maintenance-switch" />
      </div>
      <div className="mt-5 flex items-center gap-2 rounded-xl border border-white/5 bg-black/40 p-3 text-xs text-zinc-400">
        <Clock size={14} className="text-[#e5b80b]" /> Otomatis setiap Kamis 05:00–06:00 WIB (bersih-bersih data & transaksi belum bayar &gt; 3 hari).
      </div>
      {!can("maintenance", "manage") ? <p className="mt-3 text-xs text-zinc-500">Mode lihat saja.</p> : null}
    </section>
  );
};
